import React, { useState } from 'react'
import { Grid, Box, Button, Typography } from '@mui/material'
import { func } from 'prop-types'
import SugestoesObras from '../../services/http/leitores/SugestoesObras'
import SmallTextField from '../textfield/SmallTextfield'
import Dater from '../../services/DateFormat'

const FormSugestao = ({ onSubmitEnd = () => {} }) => {
  const submit = async event => {
    event.preventDefault()
    const response = await SugestoesObras().store(form, {
      notification: true,
      message: 'Sucesso ao salvar sugestão!'
    })
    if (response !== 'error') {
      setForm({ ...form, nome_obra: '', autor: '', ano: '', edicao: '' })
    }
    onSubmitEnd()
  }

  const [form, setForm] = useState({
    nome_obra: '',
    autor: '',
    ano: '',
    edicao: ''
  })

  return (
    <form onSubmit={submit}>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', p: 0, mb: 2 }}
      >
        <Typography variant="h5">Nova Sugestão </Typography>
      </Box>
      <Grid container rowSpacing={1}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <SmallTextField
                value={form.nome_obra}
                onChange={({ target }) =>
                  setForm({ ...form, nome_obra: target.value })
                }
                label="Nome da obra"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3.5}>
              <SmallTextField
                label="Autor"
                value={form.autor}
                onChange={({ target }) =>
                  setForm({ ...form, autor: target.value })
                }
                required
                inputProps={{ minLength: 6 }}
              />
            </Grid>
            <Grid item xs={12} sm={5} md={5} lg={1.5}>
              <SmallTextField
                label="Ano"
                type="number"
                inputProps={{
                  min: 1980,
                  max: Dater().formatar(new Date(), 'yyyy')
                }}
                value={form.ano}
                onChange={({ target }) =>
                  setForm({ ...form, ano: parseInt(target.value) })
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={5} md={5} lg={1.5}>
              <SmallTextField
                type="number"
                label="Edição"
                value={form.edicao}
                onChange={({ target }) =>
                  setForm({ ...form, edicao: parseInt(target.value) })
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={2} md={2} lg={1.5}>
              <Button
                sx={{
                  width: '100%',
                  height: '100%'
                }}
                type="submit"
                variant="contained"
                color="leitura"
              >
                Sugerir
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  )
}
FormSugestao.propTypes = {
  onSubmitEnd: func
}
export default FormSugestao
